import * as React from 'react'
import { Switch } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { lazy } from 'react'
import { LazyRoute } from 'Modules'

const DashboardComponentLazy = lazy(
	() => import('Pages/dashboard/components/startPage/DashboardComponent')
)

export const DashboardRoutes = () => {
	return (
		<Switch>
			<LazyRoute path={FrontUrls.dashboard} lazyComponent={DashboardComponentLazy} />
		</Switch>
	)
}
